import {createSelector} from "reselect";
import {IStore} from "modules/types/store";
import {RequestState} from "modules/enums";
import {IMAGES_URL} from "modules/constants";
import {eq} from "lodash";

export const getJSONsState = (store: IStore) => store.jsons;

export const getGameCards = createSelector(getJSONsState, ({cards}) => cards);

export const getIsLoadingSettings = createSelector(
	getJSONsState,
	({requestState}) => requestState !== RequestState.Received
);

export const getIsLoadingAvatars = createSelector(
	getJSONsState,
	({avatarsRequestState}) => avatarsRequestState === RequestState.Requested
);

export const getBackground = createSelector(
	getJSONsState,
	({background}) => `${IMAGES_URL}image/${background}`
);

export const getIsLoadingTeams = createSelector(
	getJSONsState,
	({teamsRequestState}) => teamsRequestState !== RequestState.Received
);

export const getTeams = createSelector(getJSONsState, ({teams}) => teams);
export const getTeamById = (teamId: number) =>
	createSelector(getJSONsState, ({teams}) => teams.find((t) => eq(t.id, teamId)));

export const getIsHelpsLoading = createSelector(
	getJSONsState,
	({helpsRequestState}) => helpsRequestState !== RequestState.Received
);

export const getFaqs = createSelector(getJSONsState, ({faqs}) => faqs);
export const getGuidelines = createSelector(getJSONsState, ({guidelines}) => guidelines);
export const getTerms = createSelector(getJSONsState, ({terms}) => terms);

export const getAvatars = createSelector(getJSONsState, ({avatars}) => avatars);

export const getAchievements = createSelector(getJSONsState, ({achievements}) => achievements);
export const getAchievementsIsLoading = createSelector(
	getJSONsState,
	({achievementsRequestState}) => achievementsRequestState === RequestState.Requested
);

export const getCountries = createSelector(getJSONsState, ({countries}) => countries);
export const getCountriesIsLoading = createSelector(
	getJSONsState,
	({countriesRequestState}) => countriesRequestState !== RequestState.Received
);
